<template>
    <kt-panel>
        <kt-panel-header>
            <kt-panel-header-toolbar>
                <ul class="nav nav-pills" role="tablist">
                    <li class="nav-item">
                        <a :class="['nav-link', currentTab === 1 ? 'active' : '']" href="#gateway_details"
                           @click="gotoTab(1)">
                            {{ $t('card_to_card.gateway_details') }}
                        </a>
                    </li>
                    <li class="nav-item">
                        <a :class="['nav-link', currentTab === 2 ? 'active' : '']" href="#gateway_bank_cards"
                           @click="gotoTab(2)">
                            {{ $t('card_to_card.gateway_cards') }}
                        </a>
                    </li>
                    <li class="nav-item">
                        <a :class="['nav-link', currentTab === 3 ? 'active' : '']" href="#settings"
                           @click="gotoTab(3)">
                            {{ $t('aside.settings') }}
                        </a>
                    </li>
                </ul>
            </kt-panel-header-toolbar>
        </kt-panel-header>
        <kt-panel-body>
            <div class="tab-content">
                <div :class="['tab-pane', currentTab === 1 ? 'active' : '']" id="#gateway_details">
                    <div style="margin-top: 15px" id="gateway_details"
                         aria-labelledby="gateway_details" data-parent="#gateway_details">
                        <kt-row v-if="status !== 'loading'">
                            <gateway-info></gateway-info>
                        </kt-row>
                    </div>
                </div>
            </div>
            <div class="tab-content">
                <div :class="['tab-pane', currentTab === 2 ? 'active' : '']" id="#gateway_bank_cards">
                    <div style="margin-top: 15px" id="gateway_bank_cards" aria-labelledby="gateway_bank_cards"
                         data-parent="#gateway_bank_cards"
                         v-if="status !== 'loading'">
                        <gateway-cards></gateway-cards>
                    </div>
                </div>
            </div>
            <div class="tab-content">
                <div :class="['tab-pane', currentTab === 3 ? 'active' : '']" id="#settings">
                    <div style="margin-top: 15px" id="settings" aria-labelledby="settings"
                         data-parent="#settings"
                        >
                        <setting></setting>
                    </div>
                </div>
            </div>
        </kt-panel-body>
    </kt-panel>
</template>

<script>
import {mapGetters} from 'vuex'
import gatewayInfo from "./gateway-info.vue";
import gatewayCards from "./gateway-cards.vue";
import Setting from "./settings.vue";


export default {
    components: {Setting, gatewayCards, gatewayInfo},
    computed: {
        ...mapGetters('cardToCard', [
            'form_data', 'status'
        ]),
    },
    data() {
        return {
            'hashid': this.$route.params.hashid,
            currentTab: 1
        }
    },
    mounted() {
        this.$store.dispatch('cardToCard/find', this.hashid)
    },
    methods: {
        gotoTab(index) {
            this.currentTab = index;
        }
    }
}
</script>

<style>
@media (min-width: 768px) {
    #ivr-info > div > :first-child {
        border-left: 1px solid #ddd;
    }
}
</style>